import React from 'react';
import { Route } from 'react-router-dom';

interface Props {
  path: string | string[];
  exact: boolean;
  userInfo: any;
  userLoading: boolean;
  render: Function;
}

const ProtectedRoute: React.FC<Props> = ({
  path,
  exact = false,
  userInfo,
  userLoading,
  render,
}) => {
  if (userLoading) {
    return null;
  }

  if (!userInfo && window?.location?.href) {
    window.location.href = '/login';
    return null;
  }

  if (!userInfo?.subscription && window?.location?.href) {
    window.location.href = '/pricing';
    return null;
  }

  return (
    <Route path={path} exact={exact}>
      {render()}
    </Route>
  );
};

export default ProtectedRoute;
